define( function() {
	"use strict";

	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/rquery.js
// module id = 116
// module chunks = 80